import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { numberToPrettyString } from '@cian/utils';
import { PhoneButton } from '../phone_button';
import { FavoriteButtonContainer } from '../../containers/favorite_button';
import { getFloorPlanPolygonParams } from '../../utils/map/polygon';
import { PolygonsDrawer } from '../polygons_drawer';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CANVAS_SIZE = [150, 110];
export var FlatInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(FlatInfo, _React$Component);
  var _super = _createSuper(FlatInfo);
  function FlatInfo() {
    var _this;
    _classCallCheck(this, FlatInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getDrawParams", function () {
      var floorFlatPolygons = _this.props.floorFlatPolygons;
      var points = floorFlatPolygons ? floorFlatPolygons.map(function (polygon) {
        return polygon.points;
      }) : undefined;
      return getFloorPlanPolygonParams(CANVAS_SIZE, points);
    });
    _defineProperty(_assertThisInitialized(_this), "getPhone", function () {
      var _this$props = _this.props,
        flat = _this$props.flat,
        builder = _this$props.builder;
      try {
        return flat && flat.phone ? flat.phone.countryCode + flat.phone.number : builder.phone.countryCode + builder.phone.code + builder.phone.number;
      } catch (e) {
        return '';
      }
    });
    return _this;
  }
  _createClass(FlatInfo, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        flat = _this$props2.flat,
        builder = _this$props2.builder,
        floorFlatPolygons = _this$props2.floorFlatPolygons,
        mapImageUrl = _this$props2.mapImageUrl,
        isOfferCard = _this$props2.isOfferCard;
      if (!flat) {
        return null;
      }
      var phone = this.getPhone();
      return /*#__PURE__*/_jsxs("div", {
        id: "newbuilding_mvk_fragment-flat_info",
        className: styles['container'],
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("a", {
            target: "_blank",
            href: flat.url,
            className: styles['link'],
            children: [flat.roomsTitle, " ", flat.area, " \u043C", /*#__PURE__*/_jsx("sup", {
              children: "2"
            }), " \u0437\u0430 ", numberToPrettyString(flat.price), " \u20BD"]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles['floor'],
            children: [flat.floor, " \u044D\u0442\u0430\u0436"]
          }), /*#__PURE__*/_jsx("div", {
            className: styles['builder-name'],
            children: builder.name
          }), /*#__PURE__*/_jsxs("div", {
            className: styles['buttons'],
            children: [phone && /*#__PURE__*/_jsx(PhoneButton, {
              phone: phone,
              containerStyle: styles['phone-button'],
              analyticsData: flat.analyticsData,
              isOfferCard: isOfferCard
            }), /*#__PURE__*/_jsx(FavoriteButtonContainer, {
              offerId: flat.id,
              isActive: flat.isFavorite
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['images'],
          children: [floorFlatPolygons && floorFlatPolygons.length && /*#__PURE__*/_jsx(PolygonsDrawer, {
            isSidebar: true,
            container: null,
            containerStyle: styles['floor-image'],
            polygons: floorFlatPolygons,
            defaultColor: "#e4e4e4",
            width: CANVAS_SIZE[0],
            height: CANVAS_SIZE[1],
            backgroundDrawingAlgorythm: this.getDrawParams
          }), mapImageUrl && /*#__PURE__*/_jsx("div", {
            style: {
              backgroundImage: "url(".concat(mapImageUrl, ")")
            },
            className: styles['map-image']
          })]
        })]
      });
    }
  }]);
  return FlatInfo;
}(React.Component);